import React, { useEffect, useState } from 'react'
import api from '../../../../../services/api'
import Form, { Input } from '../../../../../components/Form'
import { useHistory } from 'react-router-dom'
import { useToast } from '../../../../../hooks/toast'
import { useLoading } from '../../../../../hooks/loading'
import { useUpdateDataTable } from '../../../../../hooks/dataTable'
import { apiCreate, apiUpdate } from '../../domain/api'
import { nameActions } from '../../domain/info'
import { FormContainer } from './styles'
import { INPUT_MASK } from '../../../../../common/constants'
import { BRL } from '../../../../../utils/mask'

type IsOpenInModalProps = {
  idParent: number
  handleOnClose: () => void
}

type PromoterData = {
  id?: string
  name: string
  cpf: string
  pix_key?: string | null
  phone_number?: string | null
  commission_per_process: number | string
  promoterUser: {
    id: number
    name: string
    email: string
    password?: string
  }
}

type PromoterResponseData = {
  promoter: {
    id?: string
    name: string
    cpf: string
    pix_key?: string | null
    phone_number?: string | null
    commission_per_process: number | string
  }
  promoterUser: {
    id: number
    name: string
    email: string
    password?: string
  }
}

type TypesFormProps = {
  isOpenInModal?: false | IsOpenInModalProps
  initialValues?: PromoterData & {
    idUpdate: number
  }
  typeForm: 'create' | 'update'
}

export const FormPromoter = ({
  isOpenInModal,
  initialValues,
  typeForm
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const history = useHistory()
  const { updateDataTable } = useUpdateDataTable()

  const [defaultValues, setDefaultValues] = useState<PromoterResponseData>()

  useEffect(() => {
    if (initialValues) {
      setDefaultValues({
        promoter: {
          name: initialValues.name,
          cpf: initialValues.cpf,
          pix_key: initialValues.pix_key,
          phone_number: initialValues.phone_number,
          commission_per_process: initialValues.commission_per_process
            ? BRL(Number(initialValues.commission_per_process)).format()
            : undefined
        },
        promoterUser: {
          id: initialValues.promoterUser.id,
          name: initialValues.promoterUser.name,
          email: initialValues.promoterUser.email
        }
      })
    }
  }, [initialValues])

  const { activeLoading, disableLoading } = useLoading()

  const onSubmitForm = async (data: PromoterResponseData) => {
    const id = initialValues?.idUpdate

    data.promoter.commission_per_process = BRL(
      data.promoter.commission_per_process
    ).value

    try {
      if (typeForm === 'create') {
        try {
          const dataCreate = {
            ...data
          }
          activeLoading()
          await api.post(apiCreate(), dataCreate)
          disableLoading()
          updateDataTable()
          addToast({
            type: 'success',
            title: 'Registro criado',
            description: 'Registro criado com sucesso'
          })
          history.push(nameActions.read.to)
        } catch (error) {
          addToast({
            type: 'error',
            title: 'Erro ao adicionar o registro',
            description:
              'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
          })
          disableLoading()
          updateDataTable()
        }
      } else {
        const dataUpdate = {
          ...data
        }

        try {
          activeLoading()
          await api.put(apiUpdate(String(id)), dataUpdate)
          updateDataTable()
          disableLoading()
          history.push(nameActions.read.to)
          addToast({
            type: 'success',
            title: 'Registro atualizado',
            description: 'Registro alterado com sucesso'
          })
        } catch (error) {
          history.push(nameActions.read.to)
          addToast({
            type: 'error',
            title: 'Erro ao atualizar o registro',
            description:
              'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
          })
        }
      }
      disableLoading()
    } catch (err) {
      if (typeForm === 'create') {
        addToast({
          type: 'error',
          title: 'Erro no cadastro',
          description:
            'Ocorreu um erro ao fazer cadastro, por favor, tente novamente.'
        })
        if (isOpenInModal) isOpenInModal.handleOnClose()
      }
    }
  }

  return (
    <Form onSubmit={onSubmitForm} defaultValues={defaultValues}>
      <>
        <div className="card mb-5 mb-xl-10">
          <FormContainer className="form">
            <h4>Dados pessoais</h4>
            <div className="row mb-5">
              <Input
                name="promoter.name"
                label="Nome"
                rules={{ required: true }}
                className="col-md-4"
              />

              <Input
                name="promoter.cpf"
                label="CPF"
                rules={{ required: true }}
                className="col-md-4"
                mask={{
                  mask: INPUT_MASK.CPF
                }}
                controlled
              />

              <Input
                name="promoter.pix_key"
                label="Chave Pix"
                className="col-md-4"
              />

              <Input
                name="promoter.phone_number"
                label="Telefone/Celular"
                className="col-md-4"
                mask={{
                  mask: INPUT_MASK.CELL_PHONE
                }}
                rules={{ required: true }}
                controlled
              />

              <Input
                name="promoter.commission_per_process"
                label="Comissão por contrato"
                className="col-md-4"
                price
                rules={{ required: true }}
              />
            </div>
            <h4 className="pt-4">Informações de login</h4>
            <div className="row mb-5">
              <Input
                name="promoterUser.email"
                label="Email do Promotor"
                rules={{ required: true }}
                className="col-md-4"
              />
              <Input
                type="password"
                name="promoterUser.password"
                label="Senha"
                rules={{ required: typeForm === 'create' }}
                className="col-md-4"
              />
            </div>
          </FormContainer>
          <div className="card-footer d-flex justify-content-end py-6 px-9">
            <button type="submit" className="btn btn-primary">
              Salvar
            </button>
          </div>
        </div>
      </>
    </Form>
  )
}
